@switch (columnName) {
  @case ('location') {
    <app-text-overflow-label [text]="form?.menu?.value?.path ?? ''"></app-text-overflow-label>
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      (click)="buttonFunctions.delete()"
    ></app-ui-button>
  }
  @case ('quantityType') {
    {{ form?.quantityType?.value?.name }}
  }
  @case ('quantity') {
    {{ form?.quantity?.value }} {{ form?.quantityType?.value?.name }}
  }
  @default {
    <div class="fixed-width">
      <p [title]="form.get(columnName)?.value">{{ form.get(columnName)?.value }}</p>
    </div>
  }
}
